import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from '../../utils/store-utils';

export const thunks = {
  getClientSecret: createThunk(
    'payment/getClientSecret',
    ({ payment_method, email, amount }) =>
      api.post(WEB_API_ROUTES.payment.payment, {
        lesson_id: 1,
        payment_method,
        email,
        amount,
      })
  ),

  addPaymentMethod: createThunk('payment/addPaymentMethod', (paymentId) =>
    api.post(WEB_API_ROUTES.payment.addPaymentMethod, {
      id: paymentId,
    })
  ),

  pay: createThunk('payment/pay', ({ paymentMethodId, lessonId }) =>
    api.post(WEB_API_ROUTES.payment.pay, {
      payment_method_id: paymentMethodId,
      lesson_id: lessonId,
    })
  ),

  getTransactionsList: createThunk('payment/getTransactionsList', () =>
    api.get(WEB_API_ROUTES.payment.transactionsList)
  ),
};
